import React from 'react';
import {AuthProvider} from '../providers/AuthProvider';
import {ReactQueryDevtools} from 'react-query/devtools'
import {QueryClient, QueryClientProvider} from "react-query";
import AlertTemplate from "../common/AlertTemplate";
import {Provider as AlertProvider, positions} from 'react-alert';
import {BrowserRouter as Router} from "react-router-dom";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            staleTime: Infinity,
        },
    }
});

const alertOptions = {
    timeout: 10000,
    position: positions.BOTTOM_RIGHT,
};

const Providers = ({children}) => {

    return (
        <QueryClientProvider client={queryClient}>
            <Router>
                <AlertProvider template={AlertTemplate} {...alertOptions}>
                    <AuthProvider resetQueries={() => queryClient.resetQueries()}>
                        {children}
                    </AuthProvider>
                </AlertProvider>
                <ReactQueryDevtools initialIsOpen={false}/>
            </Router>
        </QueryClientProvider>
    );
};

export default Providers;
